import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "sx", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { DialogContent, DialogContentText } from '@mui/material';
import TAGTypography from '../TAGTypography/TAGTypography';
var FADE_TEXT = {
  webkitMaskImage: 'linear-gradient(to bottom, black 90%, transparent 100%)',
  maskImage: 'linear-gradient(to bottom, black 90%, transparent 100%)',
  overflowY: 'hide'
};

var TAGDialogContent = function TAGDialogContent(_ref) {
  var children = _ref.children,
      sx = _ref.sx,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'bodyLargeBook' : _ref$variant,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(DialogContent, _objectSpread(_objectSpread({}, props), {}, {
    sx: [FADE_TEXT, sx]
  }), React.createElement(DialogContentText, null, React.createElement(TAGTypography, {
    variant: variant
  }, children)));
};

export default TAGDialogContent;